import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {PlatformLocation} from '@angular/common';
import {HttpClient} from '@angular/common/http';

export function getLocale(): string {
  if (window.location.pathname && window.location.pathname.length > 1) {
    const potential_locale = window.location.pathname.split('/')[1];
    if (potential_locale && potential_locale.toLowerCase().match(/^[a-z]{2}(-[a-z]{2})?$/)) {
      return potential_locale;
    }
  }
  return null;
}

let originalBaseHref = null;
let appBaseHref = null;

function initAppBaseRef(platformLocation: PlatformLocation) {
  if (originalBaseHref == null) {
    originalBaseHref = platformLocation.getBaseHrefFromDOM();
    const loc = getLocale();
    if (loc) {
      appBaseHref = '/' + loc + originalBaseHref;
    } else {
      appBaseHref = originalBaseHref;
    }
    const base_href_node = document.getElementById('base-href') as any;
    if (base_href_node) {
      base_href_node.href = appBaseHref;
    }
  }
}

export function getAppBaseHref(platformLocation: PlatformLocation): string {
  return appBaseHref;
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient, platformLocation: PlatformLocation) {
  initAppBaseRef(platformLocation);
  return new TranslateHttpLoader(http, originalBaseHref + 'assets/i18n/');
}

export interface UrlParams {
  [key: string]: string;
}
export default class LocationUtil {
  public static getOwnDomainURL(): string {
    const result = [];
    result.push(window.location.protocol);
    result.push('//');
    result.push(window.location.hostname);
    if (window.location.port) {
      result.push(':');
      result.push(window.location.port);
    }
    return result.join('');
  }
  public static getParams(excludeParams?: Array<string>): UrlParams  {
    const result = {};
    const splittedURL = window.location.href.split('?');
    if (splittedURL.length > 1) {
      const t = splittedURL[1].split('&');
      for (let i = 0; i < t.length; i += 1) {
        const t2 = t[i].split('=');
        if (excludeParams && excludeParams.indexOf(t2[0]) < 0) {
          result[t2[0]] = t2.length > 1 ? t2[1] : undefined;
        }
      }
    }
    return result;
  }
}
